import { Navigate, useLocation } from "react-router-dom";
import { PageError, PageLoading } from "@/components/loading/PageLoading/PageLoading";
import { MainView } from "../../views/mypage";
import { useAuthContextValueHook } from "@/contexts/AuthContext";
import { useUserPageQuery } from "@/hooks/ReactQuery/UserPageReactQuery/UserPageReactQuery";
import { useEffect } from "react";
import { useUserPageContextActionsHook } from "@/contexts/UserPageContextProvider";

export default function Component(props) {
    const location = useLocation();
    const pathUserPageId = location?.pathname?.split('/mypage/')?.filter(r => r !== '')[0];

    const authContextValueHook = useAuthContextValueHook();

    const { data: userPageData, isLoading: userPageDataIsLoading, isError: userPageDataIsError, refetch: refetchUserPage } = useUserPageQuery({
        isLoggedIn: authContextValueHook?.isLoggedIn,
        isReady: authContextValueHook?.isReady,
        accessToken: authContextValueHook?.accessToken
    });
    const userPage = userPageData?.data?.content;

    const userPageContextActionsHook = useUserPageContextActionsHook();

    useEffect(() => {
        if (userPageData) {
            userPageContextActionsHook.onSetUserPage(userPageData?.data?.content);
        }
    }, [userPageData]);

    if (!authContextValueHook?.isReady || userPageDataIsLoading) {
        return <PageLoading />;
    }

    if (!authContextValueHook?.isLoggedIn) {
        return <Navigate to="/login" replace />;
    }

    if (userPageDataIsError) {
        return <PageError onRetry={() => refetchUserPage()} />;
    }

    // 내 페이지가 아닌 주소(예전 링크 등)는 첫 화면이 내 페이지·페이지 만들기로 보낸다
    if (!pathUserPageId || !userPage?.id || pathUserPageId !== userPage?.id) {
        return <Navigate to="/" replace />;
    }

    return <MainView />;
}